export const EVPcScrollAnchors = {
    Entities: 'list',
    Program: 'program',
    Speakers: 'speakers',
    Information: 'information',
    Map: 'map'
};
